import React from 'react';

import {ButtonBase} from '@mui/material';

export default React.memo(ButtonBase);
